import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import Services from '../../service/Services';
import BtnCrearAplicacion from './BtnCrearAplicacion'
import BtnActualizarAplicacion from './BtnActualizarAplicacion'
import ConfirmBtn from './ConfirmBtn'
import '../../assets/css/DataTable.css';
import axios from 'axios';

const ConsultarAplicaciones = ({ permisosProp }) => {

    const [servicio, setServicio] = useState([]);
    const [loading, setLoading] = useState([]);

    const getServices = new Services();

    useEffect(() => {
        const source = axios.CancelToken.source();
        setLoading(true)
        getServices.getAplicaciones().then(data => {
            if (data !==undefined) {   
                setServicio(data)
                setLoading(false)
            }
        });

        return () => {
            if (source) {
                getServices.cancelRequest();
            }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    var permisoAplicationCreate
    if (permisosProp[5].permisos[0] === "Crear") {
        permisoAplicationCreate = true
    } else {
        permisoAplicationCreate = false
    }
    var permisoAplicationUpdate
    if (permisosProp[5].permisos[1] === "Editar") {
        permisoAplicationUpdate = true
    } else {
        permisoAplicationUpdate = false
    }
    var permisoAplicationDelete
    if (permisosProp[5].permisos[2] === "Eliminar") {
        permisoAplicationDelete = true
    } else {
        permisoAplicationDelete = false
    }

    const Acciones = (rowData) => {
        return (
            <>
                {permisoAplicationUpdate ?
                    <BtnActualizarAplicacion
                        idAplicacionProp={rowData.id}
                        aplicacionProp={rowData.nombreaplicacion}
                        creadoporProp={rowData.creadopor}
                        fechacreacionProp={rowData.fechacreacion}
                        clientProp={rowData.idcliente}
                        aplicacionesProp={servicio}
                    />
                    :
                    ""
                }
                {permisoAplicationDelete ?
                    <ConfirmBtn
                        titulo="Confirmar Eliminación"
                        mensaje="¿Está seguro de eliminar Aplicación?, Recuerde que una vez se elimine, se borrará definitivamente del sistema"
                        accion="Eliminar"
                        clase="p-button-danger"
                        icono="pi pi-trash"
                        idAplicacionProp={rowData.id}
                        tooltipProp="Eliminar"
                    />
                    :
                    ""
                }
            </>
        );
    }

    const [globalFilter, setGlobalFilter] = useState(null);
    const dt = useRef(null);

    const handleChange = (e) => {
        e.preventDefault();
    };

    const header = (
        <div className="headerTable">
            {permisoAplicationCreate ?
                <BtnCrearAplicacion 
                    aplicacionesProp={servicio}
                />
                :
                ""
            }
            {loading && <p>Cargando información...</p>}
            <div>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." className="p-column-filter" keyfilter={/^[^<>*!=°|(#$%&"_)+-.:;,/?¡¿'{}]+$/}
                        onCut={handleChange} onCopy={handleChange} onPaste={handleChange}
                    />
                </span>
            </div>
        </div>
    );

    var permisosAcciones
    if (permisoAplicationUpdate === false && permisoAplicationDelete === false) {
        permisosAcciones = false
    } else {
        permisosAcciones = true
    }

    return (
        <div className="datatable-responsive-demo">
            <div className="card">
                <DataTable ref={dt} value={servicio} className="p-datatable-responsive-demo" paginator rows={10} header={header} globalFilter={globalFilter}
                    emptyMessage="Aplicación no registrada en el sistema" loading={loading}>
                    <Column className="columna" field="id" sortable header="Id Aplicación" />
                    <Column className="columna" field="nombreaplicacion" sortable header="Aplicación" />
                    <Column className="columna" field="idcliente.razonsocial" sortable header="Cliente" />
                    {permisosAcciones ?
                        <Column header="Acciones" body={Acciones} />
                        :
                        <Column />
                    }
                </DataTable>
            </div>
        </div>
    );
}

export default ConsultarAplicaciones
